import { instance as axios, setJwtToken } from "../../config/AxiosInstance";

// ------------GET CMS DATA-------------
export const fetchOverviewListApi = async (data) => {
    const endPoint = `user/feed/list` + "?" + new URLSearchParams(data).toString();
    return await axios.get(endPoint, setJwtToken());
};
// -----------------Delete User Account------------------------
export const deleteMessageApi = async (data) => {
    const endPoint = "user/comment" + '?' + new URLSearchParams(data).toString()
    return await axios.delete(endPoint, setJwtToken());
};